export default "__VITE_ASSET__abfcb633__"